import { Modal } from "@mantine/core";
import styles from "./exit-warning-modal.module.scss";

type ExitWarningModalProps = {
  isOpen: boolean;
  onContinueEditing: () => void;
  onDeleteAndLeave: () => void;
};

export const ExitWarningModal = ({
  isOpen,
  onContinueEditing,
  onDeleteAndLeave,
}: ExitWarningModalProps) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onContinueEditing}
      closeOnClickOutside={true}
      closeOnEscape={true}
      withCloseButton={false}
      classNames={{
        content: styles.modalContent,
        body: styles.modalBody,
      }}
      centered
      size={531}
    >
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            You are navigating away from a referral in progress
          </h2>
        </div>
        <div className={styles.modalActions}>
          <button
            className={`${styles.button} ${styles.deleteButton}`}
            onClick={onDeleteAndLeave}
            type="button"
          >
            Leave page
          </button>
          <button
            className={`${styles.button} ${styles.continueButton}`}
            onClick={onContinueEditing}
            type="button"
          >
            Continue editing
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ExitWarningModal;
